import { z } from 'zod'

export const loginFormSchema = z.object({
  email: z.string().min(1, 'auth:errors.emailRequired').email('auth:errors.invalidEmail'),
  password: z.string().min(1, 'auth:errors.passwordRequired'),
})

export type LoginFormValues = z.infer<typeof loginFormSchema>

export const defaultLoginValues: LoginFormValues = {
  email: '',
  password: '',
}

export const otpFormSchema = z.object({
  code: z
    .string()
    .length(6, 'auth:errors.invalidOtpCode')
    .regex(/^\d{6}$/, 'auth:errors.invalidOtpCode'),
})

export type OtpFormValues = z.infer<typeof otpFormSchema>

export const defaultOtpValues: OtpFormValues = { code: '' }

export type LoginStep = 'credentials' | '2fa'
